import { type IconType, renderIcon } from '../objects/IconsHelper';
import { CanvaSX } from '@lib/canvasx/canvasx';
import { defaultShapeProps, normalizeSpacing } from '@lib/canvasx/shapes';
import { drawRect } from '@lib/canvasx/util';

const defaultIconProps = { ...defaultShapeProps };
export type IconProps = Partial<ShapeStruct & ScaleStruct & DimensionStruct> & {
  icon: IconType;
  scale?: number;
  iconFill?: CanvasFillStrokeStyles['fillStyle'];
  opacity?: number;
};

export function measureIcon(props: IconProps): DimensionStruct {
  let {
    icon,
    scale = 1,
    width,
    height,
    scaleX = scale,
    scaleY = scale,
  } = props;

  const padding = normalizeSpacing(props.padding);

  if (typeof width !== 'number' || typeof height !== 'number') {
    width = icon.width * scaleX + padding.left + padding.right;
    height = icon.height * scaleY + padding.top + padding.bottom;
  }

  return {
    width,
    height,
  };
}

export const Icon: CanvaSXComponent<IconProps, typeof defaultIconProps> =
  function (props) {
    const {
      icon,
      scale = 1,
      scaleX = scale,
      scaleY = scale,
      iconFill = 'black',
      opacity = 1,
    } = props;
    const { ctx } = CanvaSX.context;

    const { width, height } = measureIcon(props);

    drawRect(
      ctx,
      {
        ...props,
        width,
        height,
      },
      () => {
        ctx.save();
        ctx.scale(scaleX, scaleY);

        renderIcon({
          ctx,
          icon,
          fillStyle: iconFill,
          opacity,
          useFillRule: true,
        });

        ctx.restore();
      }
    );

    return null;
  };

Icon.calculateDimensions = props => {
  const dimensions = measureIcon(props);

  props.width = dimensions.width;
  props.height = dimensions.height;

  return dimensions;
};

Icon.defaultProps = defaultIconProps;
